<div class="relative w-full max-w-[50rem]">
  @if (carouselHeight) {
    <svz-media-carousel
      [height]="carouselHeight"
      [items]="carouselItems"
      [initialItem]="carouselInitialItem"
      [canClickToExpandImage]="false"
      [isDark]="true"
      [fitContent]="config.fitContent ?? 'contain'"
      [playVideoWhenMouseHover]="false"
      renderMode="one-by-one"
    />
  }

  @if (carouselItems.length > 1) {
    <div class="m-auto flex pt-2" [style.max-width]="'inherit'">
      <button
        type="button"
        z-button
        zType="ghost"
        class="min-h-8 min-w-8 bg-transparent text-on-primary"
        [class.invisible]="mediasContainerEl && mediasContainerEl.scrollWidth === mediasContainerEl.offsetWidth"
        (click)="prevMediasPreview()"
      >
        <ng-icon name="lucideChevronLeft" class="icon-size-6 text-current"></ng-icon>
      </button>
      <div #mediasContainer class="flex-auto overflow-hidden">
        <div class="m-auto flex w-fit gap-2">
          @for (item of carouselItems; track item.url) {
            <div
              class="h-[30px] w-14 cursor-pointer overflow-hidden rounded-lg bg-gray-900"
              (click)="carousel()?.setCurrent(item)"
            >
              @if (item.type === 'image') {
                <img class="h-full w-full object-cover" [src]="item.url" alt="" />
              }
              @if (item.type === 'video') {
                <video class="h-full w-full object-cover" [src]="item.url"></video>
              }
            </div>
          }
        </div>
      </div>
      <button
        type="button"
        z-button
        zType="ghost"
        class="min-h-8 min-w-8 bg-transparent text-on-primary"
        [class.invisible]="mediasContainerEl && mediasContainerEl.scrollWidth === mediasContainerEl.offsetWidth"
        (click)="nextMediasPreview()"
      >
        <ng-icon name="lucideChevronRight" class="icon-size-6 text-current"></ng-icon>
      </button>
    </div>
  }

  <button
    type="button"
    z-button
    zType="ghost"
    class="img-viewer-close-btn absolute right-3 top-3 text-white"
    (click)="close()"
    [attr.aria-label]="'Close'"
  >
    <ng-icon name="lucideX" class="text-current"></ng-icon>
  </button>
</div>
